import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.lg};
`;
export const TreeContainer = styled.div `
  width: 100%;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
